import { render, staticRenderFns } from "./CatalogType.vue?vue&type=template&id=f56689d6&"
import script from "./CatalogType.vue?vue&type=script&lang=ts&"
export * from "./CatalogType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports